import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

function ContactForm() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const formRef = useRef(null);

  const svgContent = `<svg
   width="210mm"
   height="120mm"
   viewBox="0 0 210 120"
   version="1.1"
   id="svg1"
   inkscape:version="1.4 (86a8ad7, 2024-10-11)"
   sodipodi:docname="contactdesign.svg"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <sodipodi:namedview
     id="namedview1"
     pagecolor="#ffffff"
     bordercolor="#000000"
     borderopacity="0.25"
     inkscape:showpageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     inkscape:deskcolor="#d1d1d1"
     inkscape:document-units="mm"
     inkscape:zoom="11.33165"
     inkscape:cx="510.60526"
     inkscape:cy="25.72441"
     inkscape:window-width="1920"
     inkscape:window-height="991"
     inkscape:window-x="-9"
     inkscape:window-y="-9"
     inkscape:window-maximized="1"
     inkscape:current-layer="layer1" />
  <defs
     id="defs1" />
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1">
    <path
       style="fill:#000000;fill-rule:evenodd;stroke-width:1.8;stroke-linecap:round;stroke-miterlimit:22.4;paint-order:stroke fill markers"
       d="M 0,0 V 62.015094"
       id="path2" />
    <path
       style="fill:#000000;fill-rule:evenodd;stroke-width:1.8;stroke-linecap:round;stroke-miterlimit:22.4;paint-order:stroke fill markers"
       d="M 0,0 -14.383019,17.184906"
       id="path3" />
    <path
       style="fill:#000000;fill-rule:evenodd;stroke-width:1.8;stroke-linecap:round;stroke-miterlimit:22.4;paint-order:stroke fill markers"
       d="M -10.273585,29.886793 -12.328302,7.2849056"
       id="path4" />
    <path
       style="fill:#000000;fill-rule:evenodd;stroke-width:1.8;stroke-linecap:round;stroke-miterlimit:22.4;paint-order:stroke fill markers"
       d="M -10.273585,29.886793 -12.328302,7.2849054"
       id="path5" />
    <path
       style="fill:#808080;fill-rule:evenodd;stroke-width:1.8;stroke-linecap:round;stroke-miterlimit:22.4;paint-order:stroke fill markers"
       d="m 0,0 v 62.015094 c 0.62264151,-0.311321 1.2823513,-0.557522 1.8679245,-0.933962 0.2123022,-0.13648 1.8656368,-1.676557 2.054717,-2.054717 0.027845,-0.05569 -0.044027,-0.142765 0,-0.186792 0.044027,-0.04403 0.1427651,0.04403 0.1867925,0 0.044027,-0.04403 -0.027845,-0.131102 0,-0.186793 0.1825048,-0.365009 0.7942516,-0.957503 1.1207547,-1.120754 0.3285849,-0.164293 1.5718811,3.681223 2.054717,3.922641 0.6137749,0.306888 0.9648322,-1.229586 1.4943396,-1.49434 0.055691,-0.02784 0.142765,-0.04403 0.1867924,0 0.1392269,0.139227 0.077574,0.39655 0.1867925,0.560378 0.097688,0.146532 0.3178941,0.206512 0.3735849,0.373585 0.059069,0.177207 -0.1036138,0.404956 0,0.560377 0.2760781,0.414117 0.5947499,0.407957 0.7471699,0.560377 0.450717,0.450718 -0.129627,0.517169 0.560377,0.74717 0.553716,0.184572 0.423853,-0.287327 0.560378,-0.560377 0.02785,-0.05569 0.142765,0.04403 0.186792,0 0.196897,-0.196897 0.28553,-0.483006 0.373585,-0.74717 0.03938,-0.118138 -0.08806,-0.28553 0,-0.373585 0.04403,-0.04403 0.131102,0.02785 0.186792,0 0.399789,-0.199894 0.667262,-0.159817 0.933963,0.373585 0.02785,0.05569 -0.04403,-0.142765 0,0.186792 0.0934,0.0934 0.280188,0.0934 0.373585,0.186793 0.04403,0.04403 -0.06227,0.186792 0,0.186792 0.199952,0 0.484797,-1.045174 0.560377,-1.120754 0.17611,-0.17611 0.498113,0 0.74717,0 0.177085,0 0.592042,-0.07756 0.74717,0 0.449128,0.224564 1.738441,1.019926 2.054717,1.494339 0.370844,0.168347 0.07198,0.517551 0.186792,0.74717 0.02784,0.05569 0.142765,-0.04403 0.186792,0 0.388243,0.388242 0.364016,0.555593 0.74717,0.74717 0.389945,0.194972 -0.01636,0.552198 0.373585,0.74717 0.03832,0.01916 0.534035,0.02634 0.560378,0 0.36801,-0.36801 0.0279,-0.429389 0.186792,-0.74717 0.100398,-0.200796 0.290209,-0.351938 0.373585,-0.560377 0.04625,-0.115622 -0.05569,-0.262204 0,-0.373585 0.02784,-0.05569 0.142765,0.04403 0.186792,0 0.132083,-0.132083 -0.05907,-0.383171 0,-0.560378 0.04418,-0.132552 0.603704,-1.120754 0.74717,-1.120754 0.0096,0 -0.01197,0.524455 0,0.560377 0.117325,0.351973 0.389461,1.128693 0.74717,1.307547 0.48216,0.24108 1.422628,-1.250007 2.054717,-0.933962 0.222635,0.111317 1.883696,1.291775 2.054717,1.120755 0.09845,-0.09845 0.08834,-0.275137 0.186792,-0.373585 0.04403,-0.04403 0.142765,0.04403 0.186793,0 0.132082,-0.132083 -0.103614,-0.404957 0,-0.560378 0.145853,-0.218779 0.624246,-0.476823 0.933962,-0.373585 0.464809,0.154937 0.822344,1.009137 1.120755,1.307548 0.09845,0.09845 0.290049,0.07541 0.373585,0.186792 0.118138,0.157517 0.06865,0.40286 0.186792,0.560377 0.08354,0.111382 0.275137,0.08835 0.373585,0.186793 0.302208,0.302208 0.502862,0.905204 0.933962,1.120755 0.778561,0.38928 -0.137998,-4.279962 0.933963,-3.922642 0.584772,0.194924 1.123817,0.748191 1.681132,0.933962 0.326384,0.108795 0.607578,0.078 0.933962,0.186793 0.167072,0.05569 0.216068,0.294826 0.373585,0.373585 0.111381,0.05569 0.28553,-0.08806 0.373585,0 0.132082,0.132082 -0.05907,0.38317 0,0.560377 0.185708,0.557126 0.856882,1.34018 1.120755,1.867925 0.15889,0.317781 -0.181218,0.379159 0.186792,0.747169 0.09845,0.09845 0.275137,0.08835 0.373585,0.186793 0.04403,0.04403 -0.04403,0.142765 0,0.186792 0.796396,0.796397 2.309191,-2.881294 2.988679,-2.428302 0.353178,0.235453 0.486933,0.940326 0.560377,1.307548 0.136214,0.681065 0.32692,0.467047 0.560378,0.933962 0.148525,0.297051 -0.359959,0.195876 0.186792,0.560377 0.103614,0.06908 0.249057,0 0.373585,0 0.124528,0 0.317894,0.111382 0.373585,0 0.145432,-0.290864 0.0037,-0.932726 0.560377,-0.74717 0.384105,0.128035 1.04972,1.343065 1.49434,1.120755 0.343079,-0.171539 1.871477,-4.870813 2.054717,-5.603774 0.07997,-0.319858 0.373585,-0.825149 0.373585,-1.120754 0,-0.186793 -0.186792,-0.560378 0,-0.560378 0.584066,0 0.765597,1.69956 1.120755,2.054717 1.30079,1.300791 -0.356111,-0.899013 0.373585,0.560378 0.161212,0.322425 1.144915,-0.801381 1.307547,-0.74717 0.652168,0.217389 0.600108,0.96045 1.120754,1.307547 0.144335,0.09622 0.91169,0.58265 1.120755,0.373585 0.04434,-0.04434 0.07825,-0.595089 0.373585,-0.373585 0.626448,0.469836 0.828406,1.161373 1.49434,1.49434 1.084227,0.542113 0.935869,-1.309454 1.120754,-1.49434 0.08806,-0.08805 0.249057,0 0.373585,0 0.715284,0 0.84241,1.090237 1.49434,1.307547 0.589487,0.196496 1.004393,-0.708382 1.681132,-0.933962 1.084842,-0.361614 1.228375,0.614187 1.867925,0.933962 0.747387,0.373694 4.804809,-1.816129 5.603773,-2.615094 0.09845,-0.09845 0.08834,-0.275137 0.186793,-0.373585 0.144219,-0.14422 0.673389,0.03923 0.747169,0.186792 0.0566,0.113208 0.108519,0.482104 0.186793,0.560378 0.210363,0.210363 0.642482,-0.177558 0.933962,0.186792 0.313591,0.391988 0.522673,0.858554 0.74717,1.307547 0.08751,0.175025 0.286073,0.385354 0.373585,0.560378 0.162614,0.325227 -0.22186,0.74717 0.373585,0.74717 0.06226,0 0.152254,0.05181 0.186792,0 0.35559,-0.533385 0.615913,-1.124546 0.933962,-1.681132 0.180128,-0.315224 0.432899,-0.59402 0.560378,-0.933963 0.06559,-0.174899 -0.0453,-0.379162 0,-0.560377 l 0.373585,-0.933962 c 0.06226,-0.06226 0.147413,-0.108034 0.186792,-0.186793 0.02785,-0.05569 -0.04403,-0.142765 0,-0.186792 0.249057,-0.249057 0.589653,0.432135 0.74717,0.74717 0.170927,0.341854 1.711647,3.549056 1.867925,3.549056 0.866333,0 0.310096,-2.752565 2.054717,-2.054717 0.134429,0.05377 1.222549,0.820632 1.307547,0.933962 0.186466,0.248622 -0.195775,0.369094 0.560377,0.74717 1.112161,0.556081 0.752113,-2.141934 1.867925,-0.74717 0.167549,0.209437 0.542609,1.867925 0.747169,1.867925 0.338561,0 0.278028,-1.166372 0.560378,-1.307547 0.878098,-0.439049 0.969674,0.791542 2.241509,-0.186793 0.558355,-0.429503 1.054281,-0.944265 1.49434,-1.494339 0.08312,-0.103901 -0.01768,-0.548592 0.560377,-0.933963 0.983286,-0.655523 1.179483,0.677834 1.49434,1.307548 0.100398,0.200795 0.273187,0.359581 0.373585,0.560377 0.176109,0.352219 0.197475,0.768535 0.373585,1.120755 0.61307,1.22614 0.364489,-2.223318 0.373585,-2.24151 0.02784,-0.05569 0.124528,0 0.186792,0 0.598235,0 0.642115,0.83668 0.933962,0.933963 0.479043,0.15968 1.233695,-0.223719 1.681132,0 0.224151,0.112075 0.336227,0.448301 0.560378,0.560377 0.111381,0.05569 0.255447,-0.03938 0.373585,0 0.529484,0.176495 1.8178,1.826905 2.054717,2.241509 0.0929,0.16257 0.240936,0.988106 0.373584,1.120755 0.04403,0.04403 0.131102,-0.02784 0.186793,0 1.314281,0.65714 2.123759,-1.412686 2.801887,-2.241509 0.167279,-0.204452 0.424466,-0.333859 0.560377,-0.560378 0.06407,-0.106782 0,-0.249056 0,-0.373585 0.124528,-0.06226 0.296356,-0.07095 0.373585,-0.186792 0.103614,-0.155421 -0.132082,-0.428295 0,-0.560377 0.04403,-0.04403 0.152254,-0.05181 0.186792,0 0.463375,0.695062 0.900957,1.435583 1.120755,2.241509 0.03423,0.125505 0.05555,1.923477 0.186793,2.054717 0.01679,0.01679 0.550949,0.01414 0.560377,0 0.109219,-0.163828 0.09874,-0.384268 0.186792,-0.560377 0.352384,-0.704767 1.684203,0.278655 2.241513,0 0.6787,-0.339351 0.88338,-0.993306 1.86792,-0.74717 0.38199,0.0955 1.11779,1.123721 1.49434,0.74717 0.18834,-0.188342 0.14746,-0.707836 0.37359,-0.933963 0.25849,-0.258495 0.7133,1.137689 1.12075,0.933963 0.33845,-0.169226 1.20887,-1.286419 1.30755,-1.681132 0.0302,-0.120811 -0.0557,-0.262204 0,-0.373585 0.0278,-0.05569 0.14276,0.04403 0.18679,0 0.044,-0.04403 -0.044,-0.142765 0,-0.186793 0.044,-0.04403 0.12453,0 0.18679,0 1.17292,0 0.67964,0.933962 1.12076,0.933962 0.10765,0 1.79047,-3.394145 2.05471,-3.922641 0.41241,-0.824821 1.16929,1.100152 1.30755,1.307547 0.0345,0.05181 0.14277,-0.04403 0.18679,0 0.0881,0.08805 -0.088,0.28553 0,0.373585 0.22014,0.220137 0.55269,-0.317277 0.74717,-0.560377 0.38896,-0.486202 0.79443,-0.964062 1.12076,-1.49434 0.21581,-0.350699 0.18651,-0.87151 0.56038,-1.120755 0.45776,-0.305178 1.11893,0.06348 1.49434,-0.186792 1.8581,-1.238738 1.28538,-1.282223 2.61509,-2.801887 0.46553,-0.532032 0.37749,-0.74717 1.12075,-0.74717 0.0623,0 0.16367,-0.05781 0.1868,0 0.11791,0.294779 0.0617,0.642147 0.18679,0.933963 0.0694,0.16187 0.28621,0.220678 0.37358,0.373584 0.16636,0.291125 0.20464,0.644335 0.37359,0.933963 0.45836,0.785753 1.46472,1.808688 1.86792,2.615094 0.23003,0.460061 -0.54221,-0.168624 0.1868,0.560377 0.0984,0.09845 0.27513,0.08835 0.37358,0.186793 0.0967,0.09668 0.0901,0.650487 0.18679,0.74717 0.044,0.04403 0.13111,-0.02785 0.1868,0 0.15751,0.07876 0.19747,0.373585 0.37358,0.373585 1.20252,0 1.36864,-3.006699 1.68113,-3.73585 0.0245,-0.05723 0.12453,0 0.1868,0 0.0623,-0.124528 0.15302,-0.238515 0.18679,-0.373584 0.0552,-0.220922 -0.12711,-0.455744 0.18679,-0.560378 0.62752,-0.209172 0.75923,0.572438 1.12076,0.933962 0.22013,0.220138 0.52703,0.340241 0.74716,0.560378 0.24869,0.248685 1.01631,1.489918 1.49434,1.681132 1.22659,0.490632 2.16825,-0.373585 3.36227,-0.373585 0.24906,0 0.53994,-0.138152 0.74717,0 0.56551,-0.460931 0.32129,0.508087 0.37358,0.560377 0.0291,0.02911 0.71806,0.02911 0.74717,0 0.2714,-0.271395 1.09209,-1.630738 1.68114,-0.747169 0.0691,0.103613 -0.0557,0.262203 0,0.373584 0.21754,0.435088 0.70227,0.844172 0.93396,1.307548 0.0557,0.111381 -0.0881,0.28553 0,0.373585 0.044,0.04403 8.57784,-1.247028 8.59245,-1.307548 1.80486,-10.196678 2.15147,3.389742 2.99398,2.809579 1.63239,-1.124095 3.06863,-6.558644 6.15885,1.299855 0.074,0.188073 0.26019,0.591901 0.56038,0.373585 1.6842,-1.224871 3.60221,-3.74446 4.8566,-5.416981 0.0835,-0.111381 0.0883,-0.275137 0.18679,-0.373585 0.53237,-0.532364 1.18884,1.077112 1.49434,1.120755 1.57651,0.225215 2.37293,-1.849467 3.54906,-2.24151 1.51761,-0.50587 2.41418,9.385216 2.61509,11.39434 0.0248,0.247821 -0.13815,0.539942 0,0.74717 0.17269,0.259034 0.63786,-0.268879 0.74717,-0.560377 0.13299,-0.354624 0.078,-0.75799 0.1868,-1.120755 0.18847,-0.628245 0.65338,-1.727636 1.30754,-2.054717 0.17611,-0.08805 0.39655,-0.07757 0.56038,-0.186793 0.0518,-0.03454 -0.0604,-0.171691 0,-0.186792 1.05259,-0.263146 3.54062,0.04488 4.48302,0 4.10484,-0.195469 7.51332,-0.394397 11.20755,-2.241509 0.75156,-0.375783 0.85404,0.933962 0.93396,0.933962 0.43766,0 0.36704,-1.247464 0.74717,-1.120755 0.62271,0.20757 0.70506,0.919925 1.30755,1.120755 0.58518,0.19506 1.48323,-1.465059 2.4283,-1.307547 0.93484,0.155806 1.43902,0.853257 2.24151,1.120754 0.38238,0.127462 4.2508,0.02903 4.48302,0 0.50526,-0.06316 1.06454,-0.868672 1.68113,-0.560377 0.50879,0.254396 0.20825,0.395046 0.37358,0.560377 0.16069,0.160685 0.89256,-0.07607 1.12076,0 0.13208,0.04403 0.2415,0.142765 0.37358,0.186793 0.69101,0.230336 1.89093,0 2.6151,0 0.0769,0 0.51093,0.04944 0.56038,0 0.0984,-0.09845 0.0883,-0.275137 0.18679,-0.373585 0.16942,-0.16942 1.30123,-0.09024 1.49434,-0.186793 0.0557,-0.02785 -0.044,-0.142765 0,-0.186792 0.17932,-0.179319 1.30379,1.051876 1.53962,0.933962 0.34389,-0.171944 0.14359,-46.07621 0,-66.498113 -3.70163,-0.51797212 -4.37235,-0.0071349 -8.26539,0 -7.6619,0.0140422 -18.68075,0.02033523 -25.96066,0 -21.12423,-0.05900698 -41.0373,-0.32885401 -62.78182,0 -1.52126,0.02300678 -2.51489,-0.00279311 -3.57033,0 -2.55908,0.00677234 -4.43436,0.00571289 -7.47964,0 C 96.322077,-0.01054319 88.099779,0.02304391 82.235885,0 68.919736,-0.05232976 53.759812,-0.03747687 38.290682,0 28.221433,0.02439464 9.8327334,-0.51051431 0,0 Z"
       id="path6"
       sodipodi:nodetypes="ccsssssssssssssssssscssssssscscsscsssssscssssssssssssssssssssscssssssssssssssssssssssssssssssssssccsssssssssssssssssssssssscsscssssssssssssscssssscccsssssscsssscsssssccssssscssscsccsssscssssscssssssssssssssssccscscsssssssc" />
  </g>
</svg>`;
  const encodedSvg = encodeURIComponent(svgContent);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    const formData = {
      firstName,
      lastName,
      email,
      phone,
      message,
    };

    try {
      const response = await fetch('https://play.svix.com/in/e_VM74AF1eEEA4y32BEtKWw6GMzYo/', { // Replace with your actual webhook URL
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Form submitted successfully!');
        // Optionally, clear the form fields after successful submission
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
        setMessage('');
      } else {
        alert('Form submission failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('An error occurred. Please try again later.');
    }
  };

  useEffect(() => {
          // Example: If you have a button that triggers scrolling to this form,
          // you can add an event listener here.
          // For now, this just registers the plugin.
        }, []);

  return (
    <>
      <style>
        {`
          .contact-form-wrapper {
            background-image: url("data:image/svg+xml;utf8,${encodedSvg}");
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            padding: 50px 0; /* Add some padding around the form */
          }

          .contact-form-container {
            background-color: black;
            color: white;
            padding: 40px;
            max-width: 1100px;
            margin: 0 auto; /* Center the form within the wrapper */
            border-radius: 8px;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
          }

          .contact-form-title {
            font-family: 'Impact', 'Arial Black', sans-serif;
            font-size: 2em;
            margin-bottom: 30px;
            color: white;
            margin-top: 0;
          }

          .form-group {
            margin-bottom: 20px;
          }

          .form-group label {
            display: block;
            margin-bottom: 8px;
            font-size: 1.1em;
            font-weight: bold;
          }

          .form-group input[type="text"],
          .form-group input[type="email"],
          .form-group input[type="tel"],
          .form-group textarea {
            width: 100%;
            padding: 12px;
            background-color: #333;
            border: 1px solid #555;
            border-radius: 4px;
            color: white;
            font-size: 1em;
            box-sizing: border-box;
          }

          .form-group textarea {
            resize: vertical;
            min-height: 120px;
          }

          .form-row {
            display: flex;
            gap: 20px;
          }

          .form-row .form-group {
            flex: 1;
          }

          .submit-button {
            width: 100%;
            padding: 15px;
            background-color: white;
            color: black;
            border: none;
            border-radius: 4px;
            font-size: 1.2em;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          .submit-button:hover {
            background-color: #eee;
          }

          /* Responsive adjustments */
          @media (max-width: 768px) {
            .contact-form-container {
              padding: 20px;
              margin: 20px;
            }

            .contact-form-title {
              font-size: 2em;
            }

            .form-row {
              flex-direction: column;
              gap: 0;
            }
          }
        `}
      </style>
      <div className="contact-form-wrapper" ref={formRef}>
        <div className="contact-form-container">
        <h3 className="contact-form-title">GET IN TOUCH</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="firstName">First Name</label>
              <input
                type="text"
                id="firstName"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name</label>
              <input
                type="text"
                id="lastName"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              placeholder="Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message or Question</label>
            <textarea
              id="message"
              placeholder="Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
          </div>
          <button type="submit" className="submit-button">Get In Touch</button>
        </form>
        </div>
      </div>
    </>
  );
}

export default ContactForm;